import { Discipline } from '@centers/interfaces/discipline';
import { Resource } from '@centers/interfaces/resource';
import { Contact } from '@contacts/interfaces/contact';
import { BookingEvent } from './booking-event';
import { Article } from '@accounting/interfaces/article';
import { PriceCategory } from '@contacts/interfaces/price-category';
import { ParsedResource } from './calendar';

export interface TimeRange {
  start_time: string;
  end_time: string;
}

export interface DateRange {
  start_date: string;
  end_date: string;
}

export interface DaysInput {
  fri: boolean;
  mon: boolean;
  sat: boolean;
  sun: boolean;
  thu: boolean;
  tue: boolean;
  wed: boolean;
}
export interface ResourceSelectInfo {
  resource: Resource;
  withoutConflicts: number;
  bookingEvents: BookingEvent[];
}
export class Booking {
  id: number | string;
  center_id: number; // 1
  discipline_id: number; // 1,
  contact_id: number; // 1,
  price_category?: PriceCategory;
  price_category_id: number; // 1,
  code: string; // "AA0001",
  name: string; // "Booking 1",
  status: string; // "active",
  booking_type: string; // "booking",
  repetitive: boolean; // 0 (simple) | 1 (multiple),
  comment: string; // "Ceci est un test"
  booking_price: number;
  selected_suggested_articles: {};
  contact_subscriptions?: {};
  resources?: Resource[];
  start_date: string;
  end_date: string;
  date_range: DateRange;
  start_time: string;
  end_time: string;
  time_range: TimeRange;
  bookingEvents?: BookingEvent[];
  contact?: Contact;
  discipline?: Discipline;
  days?: DaysInput;
  reduction_articles: Article[];
  article?: Article;
  article_id: number;
  generate_order: boolean;
  period_id?: number;
  bank_holidays?: boolean;
  school_holidays?: boolean;
  created_at?: string;
  updated_at?: string;
  origin?: string;
}

export interface BookingOrganizationForm {
  id: number | string;
  center_id: number;
  discipline_id?: number;
  price_category_id?: number;
  name?: string;
  repetitive: boolean;
  comment?: string;
  resources?: number[];
  resource_id?: number;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  bookingEvents?: BookingEvent[];
  days?: DaysInput;
  period_id?: number;
  bank_holidays?: boolean;
  school_holidays?: boolean;
}

export interface PublicBookingFormData {
  status?: string;
  start_time: string;
  date: string;
  end_time: string;
  resource_id: number;
  discipline_id: number;
  subscription_category_id: number;
  payWithSubscriptions?: boolean;
  extra?: {
    resource?: ParsedResource;
    discipline?: Discipline;
  };
}

export interface ProfieMyBookingRequestsFilters {
  status?: string;
}
